import { useMemo } from 'react';
import useAxios from 'axios-hooks';
import { saveAs } from 'file-saver';
import moment from 'moment';

export const useLandscapeReports = () => {
  const [
    { data, loading, error },
    refetch,
  ] = useAxios({ url: 'member-reports/visible' });

  const [, executeDownload] = useAxios(
    { method: 'GET', responseType: 'blob' },
    { manual: true }
  );

  const downloadPdf = async (reportId, fileName) => {
    try {
      const date = `${moment().format('MMDDYYYY')}-${moment().unix()}`;
      const response = await executeDownload({
        url: `member-reports/${reportId}/download`
      });
      const sanitizedFileName = fileName.replace(/\.pdf$/i, '');
      saveAs(response.data, `${sanitizedFileName}-${date}.pdf`);
    } catch (error) {
      console.error('Error downloading PDF:', error);
    }
  };

  const getPdfUrl = (reportId) => {
    return `${process.env.REACT_APP_API_URL}member-reports/${reportId}/download?inline=true`;
  };

  return useMemo(() => ({
    data,
    loading,
    error,
    refetch,
    downloadPdf,
    getPdfUrl,
  }), [
    data,
    loading,
    error,
    refetch,
  ]);
};
